import { Component, Input, inject } from '@angular/core'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'
import { SmartquoteHelperService } from '../../../services/smartquote-helper.service'
import { CurrencyPipe } from '@angular/common'
import { LabelComponent } from 'src/app/shared/components/form-elements/label/label.component'
import { InputMoneyComponent } from 'src/app/shared/components/form-elements/input-money/input-money.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { InputQuantityComponent } from 'src/app/shared/components/form-elements/input-quantity/input-quantity.component'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { SwitchComponent } from 'src/app/shared/components/form-elements/switch/switch.component'
import { InputComponent } from 'src/app/shared/components/form-elements/input/input.component'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'

@Component({
    selector: 'sf-smartquote-quote',
    imports: [
        ReactiveFormsModule,
        NgSelectModule,
        ButtonComponent,
        CardComponent,
        InputQuantityComponent,
        LabelComponent,
        InputComponent,
        InputMoneyComponent,
        SwitchComponent,
        CurrencyPipe,
    ],
    templateUrl: './smartquote-quote.component.html',
    styleUrl: './smartquote-quote.component.scss',
})
export class SmartquoteQuoteComponent {
    public smartquoteHelperService = inject(SmartquoteHelperService)
    @Input() form!: FormGroup

    toggleFreeOfCharge() {
        const current = this.form.get('freeOfCharge')?.value
        this.form.get('freeOfCharge')?.setValue(!current, { emitEvent: true })
    }

    toggleCombinedLines() {
        const current = this.form.get('combinedLines')?.value
        this.form.get('combinedLines')?.setValue(!current, { emitEvent: true })
    }
}
